import { AttemptAndUserIdData, CartViewedData, CheckoutStepCompletedData, MetaRouterCustomTrackingEvents, OrderCompletedData, PageErrorData, PageLoadedData, PaymentInfoEnteredData, ProductAndCurrencyData, ProductsSearchedData, RemindMeData, ShippingInfoEnteredData } from './types';

export default {
  pageLoaded(pageLoadedData: PageLoadedData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.PAGE_LOADED, pageLoadedData);
    }
  },

  signedUp(signedUpData: AttemptAndUserIdData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.SIGNED_UP, signedUpData);
    }
  },
  signedIn(signedInData: AttemptAndUserIdData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.SIGNED_IN, signedInData);
    }
  },

  newsletterSubscribe(newsletterSubscribeData: AttemptAndUserIdData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.NEWSLETTER_SUBSCRIBED, newsletterSubscribeData);
    }
  },

  updateCartItem(action: "add" | "remove", updateCartItemData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      switch (action) {
        case "remove":
          window["analytics"].track(MetaRouterCustomTrackingEvents.PRODUCT_REMOVED, updateCartItemData);
          break;
        default:
          window["analytics"].track(MetaRouterCustomTrackingEvents.PRODUCT_ADDED, updateCartItemData);
      }
    }
  },

  cartViewed(cartViewedData: CartViewedData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.CART_VIEWED, cartViewedData);
    }
  },

  // CHECKOUT STARTED => SEND WHEN USER CLICKS ON "Continue to shipping information"
  checkoutStarted(checkoutStartedData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.CHECKOUT_STARTED, checkoutStartedData);
    }
  },

  // shipping_info_entered => SEND WHEN USER CLICKS ON "Go to billing information"
  shippingInfoEntered(shippingInfoEnteredData: ShippingInfoEnteredData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.SHIPPING_INFO_ENTERED, shippingInfoEnteredData);
    }
  },

  // payment_info_entered => SEND WHEN USER CLICKS ON "Continue to payment information"
  paymentInfoEntered(paymentInfoEnteredData: PaymentInfoEnteredData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.PAYMENT_INFO_ENTERED, paymentInfoEnteredData);
    }
  },

  checkoutStepCompleted(checkoutStepCompletedData: CheckoutStepCompletedData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.CHECKOUT_STEP_COMPLETED, checkoutStepCompletedData);
    }
  },

  productViewed(productViewedData: ProductAndCurrencyData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.PRODUCT_VIEWED, productViewedData);
    }
  },

  giftWrapped(action: MetaRouterCustomTrackingEvents.PRODUCT_ADDED | MetaRouterCustomTrackingEvents.PRODUCT_REMOVED, giftWrappedData: ProductAndCurrencyData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(action, giftWrappedData);
    }
  },

  orderCompleted(orderCompletedData: OrderCompletedData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.ORDER_COMPLETED, orderCompletedData);
    }
  },

  productsSearched(productsSearchedData: ProductsSearchedData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.PRODUCTS_SEARCHED, productsSearchedData);
    }
  },

  remindMe(remindMeData: RemindMeData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.REMIND_ME, remindMeData);
    }
  },

  pageError(pageErrorData: PageErrorData) {
    if (typeof window !== 'undefined' && window["analytics"] !== undefined) {
      window["analytics"].track(MetaRouterCustomTrackingEvents.PAGE_ERROR, pageErrorData);
    }
  },

}
